export default "__VITE_ASSET__BSc8Rf2K__"